/**Dependencies */
import React from "react";
import { settingsDestinos } from "../utils";

/**Components */
import { Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import { InteractiveCard } from "../components/InteractiveCard";

/**Styles */
import "../styles/home.scss";

export const CarouselCards = ({
  title,
  cardsInfo,
  seccion,
  urlService,
  selectedDates,
  subtitle,
}) => {
  return (
    <div
      className="section-about-reservation carousel-container-selector-hotel ps-lg-5 py-4 py-sm-5 py-lg-4 pe-0 m-xl-5"
      //style={{ height: "40rem" }}
    >
      <Row className="justify-content-lg-end justify-content-center m-0">
        {title && (
          <Col lg={4} sm={12} className="d-lg-grid align-items-center">
            <div className="centered-mobile">
              <div className="w-100 d-grid justify-content-center">
                <h1
                  className="text-lg-start text-center destinos-inigualables border-1 border-black border-bottom pb-3"
                  style={{ fontWeight: "700", letterSpacing: "3px" }}
                >
                  {title}
                </h1>
                {subtitle && (
                  <h3
                    className="text-start title-home d-none d-lg-flex fw-lighter mejores-destinos"
                    style={{ width: "85%" }}
                  >
                    Los mejores destinos para iniciar un recorrido lleno de
                    nuevas emociones.
                  </h3>
                )}
              </div>
            </div>
          </Col>
        )}
        <Col lg={8} sm={12}>
          <Row style={{ gap: "20px" }}>
            <Slider {...settingsDestinos} className="p-experiences">
              {cardsInfo?.map((card, index) => (
                <div
                  className="d-flex justify-content-center p-2 mb-3"
                  key={index + 1}
                >
                  <InteractiveCard
                    seccion={seccion}
                    imageSrc={card?.imagen_destino || card?.image_carousel}
                    title={card?.nombre_destino || card?.name_collection}
                    location={card?.id_destino || card?.name_collection}
                    url={card?.name_collection || urlService}
                    dates={selectedDates}
                    id={card?.id}
                  />
                </div>
              ))}
            </Slider>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
